export default {
  "content": "<path d=\"M23.207 17.793a1 1 0 01.066 1.34l-.066.074-4.5 4.5-1.414-1.414 2.793-2.793H10v-2h10.086l-2.793-2.793 1.414-1.414 4.5 4.5z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 4.5a1 1 0 011 1V12h-2V8.044l-7.386 5.745c-.36.28-.867.28-1.228 0L4 8.044V17.5h4v2H3a1 1 0 01-1-1v-13a1 1 0 011-1h18zm-9 7.232L18.729 6.5H5.27L12 11.732z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};